import {
  defFetchList,
  defFetchOne,
  defFetchField,
  defCreate,
  defUpdateOne,
  defDeleteOne,
  defUpdateStatus,
  defUploadCoverImage,
  defUploadAlbumImage,
  defUpdateAlbumImage,
  defDeleteAlbumImage,
  defCreateOrdersNotify
} from '@/api/default'

import request from '@/api/request'

const BASE_PATH = '/product'
const COVER_FEE_PATH = BASE_PATH + '/cover_fee'

export function fetchList (query) {
  return defFetchList(BASE_PATH, query)
}

export function fetchOne (id) {
  return defFetchOne(BASE_PATH, id)
}

export function fetchCancelRule (id, params) {
  return defFetchField(BASE_PATH, id, 'cancel_rule', params)
}

export function fetchRescheduleRule (id, params) {
  return defFetchField(BASE_PATH, id, 'reschedule_rule', params)
}

export function fetchInlineResource (id) {
  return request({
    url: BASE_PATH + '/' + id + '/inline_rsc',
    method: 'get'
  })
}

export function create (data) {
  return defCreate(BASE_PATH, data)
}

export function updateOne (id, data) {
  return defUpdateOne(BASE_PATH, id, data)
}

export function deleteOne (id) {
  return defDeleteOne(BASE_PATH, id)
}

export function updateStatus (id, data) {
  return defUpdateStatus(BASE_PATH, id, data)
}

export function uploadCoverImage (id, data, config) {
  return defUploadCoverImage(BASE_PATH, id, data, config)
}

export function uploadAlbumImage (id, data, config) {
  return defUploadAlbumImage(BASE_PATH, id, data, config)
}

export function updateAlbumImage (id, data) {
  return defUpdateAlbumImage(BASE_PATH, id, data)
}

export function deleteAlbumImage (id) {
  return defDeleteAlbumImage(BASE_PATH, id)
}

export function uploadIntroImage (data, config) {
  return defUploadCoverImage(BASE_PATH, '0', data, config, 'intro_image')
}

export function uploadPartnerProduct (partnerID, data) {
  return request({
    url: BASE_PATH + '/partner/' + partnerID + '/upload',
    method: 'post',
    data: data
  })
}

export function updateProductStatus (productPartnerID, data) {
  return request({
    url: BASE_PATH + '/partner/' + productPartnerID,
    method: 'put',
    data: data
  })
}

export function createProductPartner (data) {
  return request({
    url: BASE_PATH + '/partner',
    method: 'post',
    data: data
  })
}

export function createOrdersNotify (id, data) {
  return defCreateOrdersNotify(BASE_PATH, { ...data, product_id: id })
}

export function createCoverFee (data) {
  return defCreate(COVER_FEE_PATH, data)
}

export function updateCoverFee (id, data) {
  return defUpdateOne(COVER_FEE_PATH, id, data)
}

export function deleteCoverFee (id) {
  return defDeleteOne(COVER_FEE_PATH, id)
}
